@if (hotelDealData(); as hotelDealData) {
	<div data-test-id="hotel-by-deal-detail">
		<div class="flex flex-col">
			@if (carouselImages().length > 0) {
				<vp-carousel
					[contentMargin]="
						dealStatus() === 'available' ? 'small' : 'none'
					"
					[items]="carouselImages()"
					data-test-id="hotel-by-deal-detail-carousel"
				/>
			}
			@if (dealStatus() === 'available') {
				<div class="z-10 -mt-10 px-3 md:px-8">
					<div class="section-inner">
						<sb-availability-widget
							[currency]="hotelDealData.price.currency"
							[dealGuid]="hotelDealData.deal.guid"
							[dealSlug]="dealSlug()"
							[hotelGuid]="hotelDealData.hotel.guid"
							[hotelSlug]="hotelSlug()"
							[language]="currentLanguage()"
							[maxDate]="maxDate()"
							[minDate]="minDate()"
							[occupancyRestrictions]="
								hotelDealData.deal.occupancyRestrictions
							"
							[stepperConfig]="{
								useStepper: true,
								min: hotelDealData.deal.minNights,
								max: hotelDealData.deal.maxNights,
							}"
						/>
					</div>
				</div>
			}
		</div>
		<section class="bg-white section-spacing">
			<div class="section-inner section-gap flex-col">
				<div class="column-gap flex-col lg:flex-row">
					<div class="flex-col lg:w-2/3">
						@if (dealStatus() !== 'available') {
							<ng-container
								[ngTemplateOutlet]="dialog"
								[ngTemplateOutletContext]="{
									status: dealStatus(),
								}"
							/>
						}
						<header>
							<h1
								class="heading-group heading-group-lg"
								data-test-id="hotel-by-deal-detail-title"
							>
								{{ hotelDealData?.title }}
							</h1>
							<p
								class="heading-group-overline"
								role="doc-subtitle"
							>
								{{ 'global.deal' | translate }}
							</p>
						</header>

						<markdown
							[data]="hotelDealData?.content"
							class="markdown"
							data-test-id="hotel-by-deal-detail-description"
						/>

						<div class="list-bullets">
							<ul data-test-id="hotel-by-deal-detail-usps">
								@for (
									item of hotelDealData?.usps || [];
									track $index
								) {
									<li>{{ item }}</li>
								}
							</ul>
						</div>
						@if (hotelDealData?.hotel) {
							<h2
								class="running-head running-head-center"
								data-test-class="hotel-header"
							>
								{{ hotelDealData.hotel.name }}
							</h2>
							@if (hotelDealData.hotel.images?.length > 0) {
								<vp-mini-carousel
									[items]="hotelImages()"
									aspectRatio="21:9"
								/>
							}
							<vp-tab-menu
								color="white"
								data-test-id="hotel-info-tabs"
							>
								<vp-tab-menu-item
									[content]="facilitiesRef"
									[label]="'global.facilities' | translate"
									name="facilities"
								/>
								<vp-tab-menu-item
									[content]="goodToKnowsRef"
									[label]="'global.good-to-know' | translate"
									name="good-to-knows"
								/>
								<vp-tab-menu-item
									[content]="mapRef"
									[label]="'global.map' | translate"
									name="map"
								/>
							</vp-tab-menu>

							<ng-template #facilitiesRef>
								<vp-list-grid
									[listItems]="
										hotelDealData.hotel?.facilities || []
									"
									[name]="'hotel-facilities'"
									[sheetTitle]="
										('global.hotel.label' | translate) +
										' ' +
										('global.facilities' | translate)
									"
									[useCol2]="true"
								/>
							</ng-template>
							<ng-template #goodToKnowsRef>
								<vp-list-grid
									[listItems]="
										hotelDealData.hotel?.goodToKnows || []
									"
									[name]="'hotel-good-to-knows'"
									[sheetTitle]="
										'global.good-to-know' | translate
									"
									[useCol2]="false"
								/>
							</ng-template>
							<ng-template #mapRef>
								<vp-google-map
									[lat]="hotelDealData.hotel.address.latitude"
									[long]="
										hotelDealData.hotel.address.longitude
									"
								/>
							</ng-template>

							<h2
								class="running-head running-head-center"
								data-test-class="conditions-header"
							>
								{{ 'global.conditions' | translate }}
							</h2>
							<markdown
								[data]="
									hotelDealData.deal.conditions?.[0]?.content
								"
								class="mt-2 sm:mt-3"
								data-test-id="conditions-content"
							/>
							<vp-sheet
								[isLoading]="false"
								[triggerId]="'conditions-trigger-sheet'"
								sheetWidth="third"
							>
								<div
									#sheetTrigger
									data-test-id="conditions-sheet-trigger"
									id="conditions-trigger-sheet"
									role="button"
									tabindex="0"
								>
									{{
										'storyblok.pages.hotel-by-deal.conditions.text'
											| translate
									}}
									<span
										class="text-link cursor-pointer"
										id="conditions-trigger-sheet"
										vc-clicked
										vp-sheet-trigger
									>
										{{
											'storyblok.pages.hotel-by-deal.conditions.link'
												| translate
										}}
									</span>
								</div>
								<vp-sheet-header>
									<h2 data-test-id="conditions-content-title">
										{{ 'global.conditions' | translate }}
									</h2>
								</vp-sheet-header>
								<vp-sheet-content
									id="sheet-content"
									tabindex="0"
								>
									<markdown
										[data]="
											hotelDealData.deal.conditions?.[0]
												?.terms
										"
										data-test-id="conditions-content-sheet"
									/>
								</vp-sheet-content>
							</vp-sheet>
						}
					</div>

					<div class="flex-col lg:w-1/3">
						@if (hotelDealData.price?.amount !== undefined) {
							<vp-persuade-card
								[ctaText]="
									dealStatus() === 'available'
										? ('global.book-directly' | translate)
										: ('storyblok.deals.watch-other-deals'
											| translate)
								"
								[ctaUrl]="
									dealStatus() === 'available'
										? hotelDealData.bookingToolRedirectUrl
										: '/'
								"
								[imageRibbon]="hotelDealData.deal.ribbonText"
								[images]="dealImages()"
								[isTransparentImage]="
									dealStatus() !== 'available'
								"
								[price]="
									dealStatus() === 'available'
										? hotelDealData.price
										: undefined
								"
								[pricingToolTip]="{
									occupancy: hotelDealData.pricingToolTip,
								}"
								[reversedCtaColumn]="true"
								[title]="
									dealStatus() === 'available'
										? ('storyblok.pages.hotel-by-deal.deal-card.title'
											| translate)
										: ('storyblok.pages.hotel-by-deal.deal-card.unavailable'
											| translate)
								"
								[useVerticalCard]="true"
								ctaType="btn-secondary"
								currency="EUR"
								data-test-id="cta-card"
								headingType="h2"
							>
								<ng-container content>
									<markdown
										[data]="
											hotelDealData.deal.bulletContent
										"
										class="list-checkmarks"
									/>
								</ng-container>
							</vp-persuade-card>
						}

						@if (hotelDealData?.hotel?.rating?.score) {
							<vp-rating
								[isHorizontal]="true"
								[numberOfRatings]="
									hotelDealData.hotel.rating.numberOfRatings
								"
								[score]="hotelDealData.hotel.rating.score"
							/>
						}
					</div>
				</div>
			</div>
		</section>
	</div>
}

<ng-template #dialog let-status="status">
	<vp-alert
		[emphasized]="true"
		data-test-id="deal-dialog"
		type="dialog--warning"
	>
		<div class="flex flex-col">
			<span
				class="text-base font-semibold md:text-xl"
				data-test-id="title"
			>
				{{ `storyblok.deals.status.${status}.title` | translate }}
			</span>
			<span class="text-sm md:text-lg" data-test-id="content">
				{{ `storyblok.deals.status.${status}.description` | translate }}
				<a
					class="text-link"
					routerLink="{{
						`/${currentLanguage() === rootLanguage ? '' : currentLanguage()}`
					}}"
				>
					{{ 'storyblok.deals.watch-other-deals' | translate }}
				</a>
			</span>
		</div>
	</vp-alert>
</ng-template>
